export function formatPhoneNumber(phoneNumber: string): string {
    const cleaned = phoneNumber.replace(/\D/g, '')

    return `+7 ${cleaned.slice(1, 4)} ${cleaned.slice(4, 7)}-${cleaned.slice(7, 9)}-${cleaned.slice(9)}`
}

export function formatPrice(price: string | number): string {
    return (
        Number(price).toLocaleString('ru-RU').replaceAll(' ', '&nbsp;') +
        '&nbsp;₽'
    )
}

export function stripHtml(html: string | null) {
    if (!html) return ''
    return html
        .replace(/<[^>]*>/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
}
